import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { FaArrowLeft, FaMapMarkerAlt, FaClock, FaPhone, FaStar } from 'react-icons/fa';
import { Shop } from '../../firebase/firestore';

interface ShopDetailPageProps {
  shop: Shop;
  onBack: () => void;
}

const Container = styled.div`
  padding: ${theme.spacing.lg};
`;

const BackButton = styled.button`
  background: ${theme.colors.white};
  color: ${theme.colors.secondary};
  border: 2px solid ${theme.colors.lightGray};
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.lg};
`;

const Card = styled.div`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.md};
  padding: ${theme.spacing.xl};
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${theme.colors.secondary};
  margin-bottom: ${theme.spacing.md};
`;

const Meta = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.lg};
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  color: ${theme.colors.mediumGray};
`;

const ServiceTag = styled.span`
  display: inline-block;
  background: ${theme.colors.lightGray};
  color: ${theme.colors.secondary};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.sm};
  font-size: 0.85rem;
  margin-right: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.sm};
`;

const ActionButton = styled.button`
  background: ${theme.colors.primary};
  color: ${theme.colors.white};
  border: none;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`;

const ShopDetailPage: React.FC<ShopDetailPageProps> = ({ shop, onBack }) => {
  return (
    <Container>
      <BackButton onClick={onBack}>
        <FaArrowLeft /> Back to marketplace
      </BackButton>

      <Card>
        <Title>{shop.name}</Title>
        <Meta>
          <MetaItem><FaMapMarkerAlt /> {shop.location}</MetaItem>
          <MetaItem><FaClock /> {Object.entries(shop.hours).map(([day, hours]) => 
            hours.closed ? `${day}: Closed` : `${day}: ${hours.open} - ${hours.close}`
          ).join(', ')}</MetaItem>
          <MetaItem>
            <FaStar style={{ color: theme.colors.warning }} /> {shop.rating} ({shop.reviewCount} reviews)
          </MetaItem>
        </Meta>

        <div style={{ marginBottom: theme.spacing.lg }}>
          {shop.services.map((s, i) => (
            <ServiceTag key={i}>{s}</ServiceTag>
          ))}
        </div>

        <ActionButton onClick={() => window.open(`tel:${shop.phone}`, '_self')}>
          <FaPhone /> Call {shop.phone}
        </ActionButton>
      </Card>
    </Container>
  );
};

export default ShopDetailPage;



